import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';

export class StyleOneSectionTitle extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { Data, isColorW } = this.props;
    return (
      <div className='system_title'>
        <div className='title_back' style={{ background: `url(${Data.url}) no-repeat`}}>
          <div className='after_flex' style={{ marginTop: '-10px'}}>
            <div className={!isColorW ? 'back_title_text' : 'back_title_text white'}>{Data.title}</div><div className={!isColorW ? 'title_tips' : 'title_tips white'}>{Data.subtitle}</div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleOneSectionTitle);



// WEBPACK FOOTER //
// ./src/features/style-one/StyleOneSectionTitle.js